export enum CasinPlanDiagramDirectionTypes {
    directional,
    horizontal,
    vertical
}